/* unplugin-vue-components disabled */import script from "./SingleFieldManager.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleFieldManager.vue?vue&type=script&setup=true&lang=js"

import "./SingleFieldManager.vue?vue&type=style&index=0&id=2428b1c6&lang=scss"

const __exports__ = script;

export default __exports__